<script>
import { usePageField } from '@voix/composables/usePageField'

export default {
  props: {
    topBackgroundColor: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    inputBackgroundColor: {
      type: String,
      required: false,
    },
    inputColor: {
      type: String,
      required: false,
    },
    buttonBackgroundColor: {
      type: String,
      required: false,
    },
    buttonColor: {
      type: String,
      required: false,
    },
    ctaText: {
      type: String,
      required: false,
    },
    ctaButtonText: {
      type: String,
      required: false,
    },
    menu: {
      type: Object,
      required: false,
      default: () => ({ menu_items: [] }),
    },
    legalMenu: {
      type: Object,
      required: false,
      default: () => ({ menu_items: [] }),
    },
  },

  setup() {
    const pageField = usePageField()
    const hideFooterNewsletter = pageField.get('hideFooterNewsletter', false)

    return {
      hideFooterNewsletter,
    }
  },

  methods: {

    stringToSlug(str) {
      if (!str)
        return ''

      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      const to = 'aaaaeeeeiiiioooouuuunc------'
      for (let i = 0, l = from.length; i < l; i++)
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },

    footerChildClasses(name) {
      const classes = [`footer-nav-${this.stringToSlug(name)}`]

      if (this.$voix.breakpoint.value === 'mobile' || this.$voix.breakpoint.value === 'tablet')
        classes.push('hidden')

      return classes
    },
  },
}
</script>

<template>
  <div class="relative bg-[url('/imgs/blue-project/backgrounds/footer-background.jpg')] bg-no-repeat bg-cover">
    <div class="h-full w-full absolute top-0 left-0 bg-blueproject-darkblue opacity-95" />
    <slot name="newsletter-signup">
      <ClientOnly v-if="!hideFooterNewsletter.value">
        <NewsletterFooterSignup
          :top-background-color="topBackgroundColor"
          :background-color="backgroundColor"
          :input-background-color="inputBackgroundColor"
          :input-color="inputColor"
          :button-background-color="buttonBackgroundColor"
          :button-color="buttonColor"
          :cta-text="ctaText"
          :cta-button-text="ctaButtonText"
        />
      </ClientOnly>
    </slot>
    <footer class="container mx-auto py-4 md:pb-16 md:px-32 relative z-10">
      <div class="pb-16 font-sans tracking-footer-links">
        <!-- Logo -->
        <div class="flex justify-center mb-16">
          <a href="https://www.atlantisbahamas.com/" class="text-white">
            <LogosAtlantisLogo style="width: 190px" />
          </a>
        </div>

        <!-- Social Media -->
        <ul class="flex justify-center text-xl">
          <li class="mx-2">
            <a
              class="text-white"
              href="https://facebook.com/atlantisbahamas"
              target="_blank"
            >
              <Icon class="w-6 h-6" name="simple-icons:facebook" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-white"
              href="https://www.youtube.com/atlantisbahamasofficial"
              target="_blank"
            >
              <Icon class="w-6 h-6" name="simple-icons:youtube" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-white"
              href="https://www.pinterest.com/atlantisbahamas"
              target="_blank"
            >
              <Icon class="w-6 h-6" name="simple-icons:pinterest" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-white"
              href="https://instagram.com/atlantisbahamas"
              target="_blank"
            >
              <Icon class="w-6 h-6" name="simple-icons:instagram" />
            </a>
          </li>
          <li class="mx-2">
            <a
              class="text-white"
              href="https://twitter.com/atlantisbahamas"
              target="_blank"
            >
              <Icon class="w-6 h-6" name="simple-icons:x" />
            </a>
          </li>
        </ul>

        <!-- Main Menu -->
        <!-- <ul

          class="flex flex-col md:flex-row justify-center mb-3 md:px-0 w-full space-y-4 md:space-y-0 md:space-x-8"
        >
          <li
            v-for="(topMenuItem) in menu.menu_items[0].children"
            :key="topMenuItem.id"
            class="uppercase pb-4 md:pb-0 border-b md:border-b-0 border-white text-white"
          >
            <div class="flex justify-center items-center">
              <a
                v-cloak
                :href="topMenuItem.permalink"
                :rel="topMenuItem.rel"
                class="text-white text-sm"
              >
                {{ topMenuItem.name }}
              </a>
            </div>
          </li>
        </ul> -->

        <!-- Legal Menu -->
        <div class="px-16 text-white text-xs text-center mt-8">
          <div>
            <span
              v-for="topMenuItem in legalMenu
                .menu_items"
              :key="topMenuItem.id"
              class="border-r border-white last:border-r-0 pr-1 mr-1"
            >
              <a
                class="text-white"
                :href="topMenuItem.permalink"
                v-html="topMenuItem.name"
              />
            </span>
          </div>
          <div class="mt-1">
            <span
              class="border-r border-white last:border-r-0 pr-1 mr-1"
            >
              <a class="ot-sdk-show-settings" href="javascript:void(0)">
                Cookie Settings
              </a>
            </span>
            <span
              class="border-r border-white last:border-r-0 pr-1 mr-1"
            >
              <a
                href="https://privacyportal.onetrust.com/webform/1a83e5ad-9ea4-49fa-91d0-295c0bddffd1/06533f77-836b-420f-bac4-74f4315462e8"
              >Exercise Your Privacy Rights</a>
            </span>
            <span
              class="border-r border-white last:border-r-0 pr-1 mr-1"
            >
              <a
                href="https://privacyportal.onetrust.com/webform/1a83e5ad-9ea4-49fa-91d0-295c0bddffd1/06533f77-836b-420f-bac4-74f4315462e8"
              >Do Not Sell or Share My Personal Information</a>
            </span>
            <span
              class="border-r border-white last:border-r-0 pr-1 mr-1"
            >
              <a href="tel:1-800-285-2684">1-800-Atlantis</a>
            </span>
          </div>
        </div>

        <!-- Copyright -->
        <div
          class="px-16 text-xs text-white text-center mt-3 opacity-75"
        >
          &copy; Atlantis. All rights reserved.
        </div>
      </div>
    </footer>
  </div>
</template>
